import React from "react";
import styled from "@emotion/styled";
import Tooltip from '@mui/material/Tooltip';
import SellIcon from '@mui/icons-material/Sell';
import ErrorIcon from '@mui/icons-material/Error';
import AdjustIcon from '@mui/icons-material/Adjust';
import { useTheme } from "@mui/styles";
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useDispatch, useSelector } from "react-redux";
import { selectLeadActionsNavSelection, setLeadActionNavMenuSelection } from "../../../slices/sessionDataSlice";
import { Button, NavIndex, NavText, NavigationContainer, SideBarNavHeader, Typography } from "../../../StyledComponents";

const LeadActionsNav = ({ mortgageData, leadOutcome, reportsNumber, leadStatus, handleCloseModal, leadAssigneesCount }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const navSelection = useSelector(selectLeadActionsNavSelection)
  
  const changeSelection = (content) => {
    dispatch( setLeadActionNavMenuSelection(content))
  }

  return (
    <ModalNavRail className="modal">
      <ModalNavHeader
        className="modal"
        $financialsPresent={mortgageData.financialsPresent}
      >
        Actions
      </ModalNavHeader>
      <NavList>
          {navSelection === 'reports' ?
            <ListItemNav selected top>
              <NavIndex className="nav-index">
                <SummarizeIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Reports ({reportsNumber})</NavText>
            </ListItemNav>
          : reportsNumber > 0 ?
            <ListItemNav onClick={() => changeSelection('reports')} top>
              <NavIndex className="nav-index">
                <SummarizeIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Reports ({reportsNumber})</NavText>
            </ListItemNav>
          :
            <ListItemNav top disabled>
              <NavIndex className="nav-index">
                <SummarizeIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Reports ({reportsNumber})</NavText>
            </ListItemNav>
          }
          {navSelection === 'notes' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <EditNoteIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Notes ({mortgageData.mortgageNotes.length})</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('notes')}>
              <NavIndex className="nav-index">
                <EditNoteIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Notes ({mortgageData.mortgageNotes.length})</NavText>
            </ListItemNav>
          }
          {navSelection === 'compareRecords' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <FileCopyIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Compare and Update Records</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('compareRecords')}>
              <NavIndex className="nav-index">
                <FileCopyIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Compare and Update Records</NavText>
            </ListItemNav>
          }
          {navSelection === 'propertyDetails' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <HomeWorkIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Property Details</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('propertyDetails')}>
              <NavIndex className="nav-index">
                <HomeWorkIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Property Details</NavText>
            </ListItemNav>
          }
          {!mortgageData.financialsPresent ?
            navSelection === 'provideTerms' || navSelection === 'provideFinancialsModal' ?
              <ListItemNav attention selected style={{padding: '0.1rem 0 0 0.3rem'}}>
                <NavIndex className="nav-index">
                  <AttachMoneyIcon fontSize="large" style={{color: `${theme.accent.caution.primary}`}} />
                </NavIndex>
                <NavText className="main">Provide Original Terms</NavText>
                <ErrorIcon style={{margin: '0 0 2.4rem 0.8rem', width: '1.2rem', color: `${theme.accent.caution.primary}`}} />
                <NavText className="label" style={{margin: '0 0 2.4rem 0', color: `${theme.accent.caution.primary}`}}>ToDo</NavText>
              </ListItemNav>
            :
              <ListItemNav 
                attention 
                onClick={mortgageData.status !== 'inactive' ? () => changeSelection('provideTerms') : null}
                disabled={mortgageData.status === 'inactive'}
                style={{padding: '0.1rem 0 0 0.3rem'}}
              >
                <NavIndex className="nav-index">
                  <AttachMoneyIcon fontSize="large" style={{color: `${theme.accent.caution.primary}`}} />
                </NavIndex>
                <NavText className="main">Provide Original Terms</NavText>
                <ErrorIcon style={{margin: '0 0 2.4rem 0.8rem', width: '1.2rem', color: `${theme.accent.caution.primary}`}} />
                <NavText className="label" style={{margin: '0 0 2.4rem 0', color: `${theme.accent.caution.primary}`}}>ToDo</NavText>
              </ListItemNav>
          :
            <></>
          }
          {navSelection === 'targetOutcome' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <FlagCircleIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">
                {leadOutcome === 'unassigned' ?
                  `Assign Target Outcome`
                : leadOutcome === 'renegotiation' ?
                  `Change To Refinance`
                :
                  `Change To Renegotiation`
                }
              </NavText>
            </ListItemNav>
          :
            <ListItemNav 
              onClick={mortgageData.status !== 'inactive' ? () => changeSelection('targetOutcome') : null}
              disabled={mortgageData.status === 'inactive'}
            >
              <NavIndex className="nav-index">
              <FlagCircleIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">
                {leadOutcome === 'unassigned' ?
                  `Assign Target Outcome`
                : leadOutcome === 'renegotiation' ?
                  `Change To Refinance`
                :
                  `Change To Renegotiation`
                }
              </NavText>
            </ListItemNav>
          }
          {mortgageData.originalLoanAmount && mortgageData.activeLead ?
            navSelection === 'editTargets' ?
              <ListItemNav selected>
                <NavIndex className="nav-index">
                  <AdjustIcon fontSize="large" />
                </NavIndex>
                <NavText className="main">
                  Change Refinance Targets</NavText>
              </ListItemNav>
            :
              <ListItemNav 
                onClick={mortgageData.status !== 'inactive' ? () => changeSelection('editTargets') : null}
                disabled={mortgageData.status === 'inactive'}
              >
                <NavIndex className="nav-index">
                  <AdjustIcon fontSize="large" />
                </NavIndex>
                <NavText className="main">Change Refinance Targets</NavText>
              </ListItemNav>
          : mortgageData.activeLead ?
            <Tooltip
              componentsProps={{tooltip: {sx: {
                color: `${theme.palette.common.white}`,
                backgroundColor: `${theme.palette.common.black}`,
                fontSize: "2rem",
                margin: ' 0'
              }}}}
              PopperProps={{modifiers: [{
                name: "offset",
                options: {
                  offset: [0, -8],
                },
              }]}}
              title={<div style={{display: 'flex', flexDirection: 'column', justifyContent: "center", width: '14rem'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <p style={{fontSize: "1rem", fontWeight: "600", padding: "0 0.5rem", margin: '0'}}>no financial data provided</p>
                </div>
              </div>} 
              placement="right"
              arrow
            >
              <ListItemNav disabled>
                <NavIndex className="nav-index">
                  <AdjustIcon fontSize="large" />
                </NavIndex>
                <NavText className="main">Change Refinance Targets</NavText>
              </ListItemNav>
            </Tooltip>
          :
            <ListItemNav disabled>
              <NavIndex className="nav-index">
                <AdjustIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Change Refinance Targets</NavText>
            </ListItemNav>
          }
          {navSelection === 'editTags' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <SellIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Tags</NavText>
            </ListItemNav>
          :
            <ListItemNav 
              onClick={mortgageData.status !== 'inactive' ? () => changeSelection('editTags') : null}
              disabled={mortgageData.status === 'inactive'}
            >
              <NavIndex className="nav-index">
                <SellIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Tags</NavText>
            </ListItemNav>
          }
          {navSelection === 'addAssignees' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <PersonAddIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">
                {leadAssigneesCount > 0 ?
                  `Manage Assignees (${mortgageData.assigneeIds.length ? (leadAssigneesCount + mortgageData.assigneeIds.length) : (leadAssigneesCount)})`
                :
                  `Add Assignees`
                }
              </NavText>
            </ListItemNav>
          :
            <ListItemNav 
              onClick={mortgageData.status !== 'inactive' ? () => changeSelection('addAssignees') : null}
              disabled={mortgageData.status === 'inactive'}
            >
              <NavIndex className="nav-index">
              <PersonAddIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">
                {leadAssigneesCount > 0 ?
                  `Manage Assignees (${mortgageData.assigneeIds.length ? (leadAssigneesCount + mortgageData.assigneeIds.length) : (leadAssigneesCount)})`
                :
                  `Add Assignees`
                }
              </NavText>
            </ListItemNav>
          }
      </NavList>
          <NavFooter $financialsPresent={mortgageData.financialsPresent}>
            <FooterButton
              className={mortgageData.status === 'inactive' ? 'primaryDisabled' : navSelection === 'investigateLead' ? "primaryActive disabled" : "primary" }
              disabled={navSelection === 'investigateLead' || mortgageData.status === 'inactive'}
              onClick={navSelection === 'investigateLead' || mortgageData.status === 'inactive' ? 
                  null 
                : leadStatus === 'awaitingAction' ?
                  () => changeSelection('investigateLead')
                : leadStatus === 'investigating' ?
                  () => changeSelection('beginClosingLead')
                : leadStatus === 'closing' ?
                  () => changeSelection('finalizeLead')
                : 
                  () => changeSelection('confirmUpdate')
                }
            >
              {leadStatus === 'awaitingAction' ?
                <Typography className="small">Open Investigation</Typography>
              : leadStatus === 'investigating' ?
                <Typography className="small">Designate as Closing</Typography>
              : leadStatus === 'closing' ?
                <Typography className="small">Finalize</Typography>
              :
                <Typography className="small">Confirm Updates</Typography>
              }
            </FooterButton>
            {leadStatus !== 'awaitingUpdate' &&
              <FooterButton
                $dismiss
                className={navSelection === 'dismissLead' ? "dismissFocus disabled" : (leadStatus === 'awaitingUpdate' || !leadStatus || mortgageData.status === 'inactive') ? "dismissDisabled" : "dismiss" }
                disabled={navSelection === 'dismissLead' || (leadStatus === 'awaitingUpdate' || !leadStatus) || mortgageData.status === 'inactive'}
                onClick={(navSelection === 'dismissLead' || (leadStatus === 'awaitingUpdate' || !leadStatus) || mortgageData.status === 'inactive') ? null : () => changeSelection('dismissLead')}
              >
                <Typography className="small">
                  {leadStatus === 'awaitingAction' ?
                    `Dismiss Lead`
                  :
                    `Dismiss Investigation`
                  }
                </Typography>
              </FooterButton>
            }
            <FooterButton
              className="neutral"
              $extraGap={mortgageData.financialsPresent}
              onClick={() => handleCloseModal()}
            >
              <Typography className="small">Close Window</Typography>
            </FooterButton>
          </NavFooter>
    </ModalNavRail>
  )
}

const ModalNavRail = styled(NavigationContainer)(({ theme }) => `
  &.modal {
    grid-column: 1;
    grid-row: 2;
    min-height: 0;
    max-height: 100%;
    background: ${theme.palette.common.cardBackground};
    border: 0.1rem solid ${theme.palette.common.grayBorder};
    border-radius: 0.8rem;
    box-shadow: none;
    overflow: hidden;
  }
`)

const ModalNavHeader = styled(SideBarNavHeader)(({ theme, $financialsPresent }) => `
  &.modal {
    flex: 0 0 auto;
    margin: 0;
    padding: ${$financialsPresent ? '1rem 1rem 0.7rem 1rem' : '1.2rem 1rem 0.7rem 1rem'};
    color: ${theme.palette.common.black};
    font-size: 1.05rem;
    font-weight: 750;
    border-right: none;
    border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
    background: ${theme.palette.common.grayBorderLight};
  }
`)

const NavList = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

const NavFooter = styled.div(({ theme, $financialsPresent }) => `
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: auto;
  padding: ${$financialsPresent ? '1rem' : '0.9rem 1rem 1rem'};
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const FooterButton = styled(Button)(({ theme, $extraGap, $dismiss }) => `
  && {
    width: 100%;
    min-height: ${$dismiss ? '3rem' : '3.2rem'};
    margin: ${$extraGap ? '1.1rem 0 0 0' : '0'};
    padding: 0.78rem 1rem;
    border-radius: 0.9rem;
    border-width: 0.1rem;
    border-style: solid;
    font-size: 0.98rem;
    font-weight: 760;
    line-height: 1.15;
    letter-spacing: 0;
    box-shadow: 0 0.45rem 1rem rgba(15, 23, 42, 0.08);
    transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease, box-shadow 140ms ease, transform 120ms ease;

    .small {
      width: 100%;
      min-height: 0;
      color: inherit;
      font-size: 0.98rem;
      font-weight: 760;
      line-height: 1.15;
      text-align: center;
      letter-spacing: 0;
    }

    &.primary {
      color: ${theme.palette.common.white};
      border-color: rgba(14, 132, 75, 0.84);
      background: linear-gradient(180deg, #22B24A 0%, #169B35 100%);
      box-shadow: 0 0.55rem 1.25rem rgba(22, 163, 74, 0.22), inset 0 0.1rem 0 rgba(255, 255, 255, 0.22);
    }

    &.primary:hover {
      color: ${theme.palette.common.white};
      border-color: rgba(13, 118, 66, 0.92);
      background: linear-gradient(180deg, #1FAA47 0%, #128D30 100%);
      box-shadow: 0 0.7rem 1.45rem rgba(22, 163, 74, 0.26), inset 0 0.1rem 0 rgba(255, 255, 255, 0.2);
      transform: translateY(-0.05rem);
    }

    &.primary:active {
      background: linear-gradient(180deg, #148C32 0%, #0E7D2A 100%);
      box-shadow: 0 0.25rem 0.7rem rgba(22, 163, 74, 0.2), inset 0 0.12rem 0.2rem rgba(8, 61, 31, 0.24);
      transform: translateY(0);
    }

    &.primaryActive,
    &.primaryDisabled {
      color: #7C8A93;
      border-color: #D6DDE5;
      background: linear-gradient(180deg, #F6F8FA 0%, #EDF1F5 100%);
      box-shadow: inset 0 0.1rem 0 rgba(255, 255, 255, 0.9);
      cursor: not-allowed;
      transform: none;
    }

    &.dismiss {
      color: #A22424;
      border-color: rgba(191, 49, 49, 0.34);
      background: linear-gradient(180deg, #FFF4F4 0%, #FDE7E7 100%);
      box-shadow: 0 0.45rem 1rem rgba(153, 27, 27, 0.1), inset 0 0.1rem 0 rgba(255, 255, 255, 0.72);
    }

    &.dismiss:hover {
      color: ${theme.palette.common.white};
      border-color: rgba(168, 35, 35, 0.86);
      background: linear-gradient(180deg, #C94141 0%, #A82626 100%);
      box-shadow: 0 0.65rem 1.25rem rgba(153, 27, 27, 0.2), inset 0 0.1rem 0 rgba(255, 255, 255, 0.18);
      transform: translateY(-0.05rem);
    }

    &.dismiss:active {
      background: linear-gradient(180deg, #A82626 0%, #8F1F1F 100%);
      box-shadow: 0 0.25rem 0.7rem rgba(153, 27, 27, 0.16), inset 0 0.12rem 0.2rem rgba(91, 16, 16, 0.24);
      transform: translateY(0);
    }

    &.dismissFocus,
    &.dismissDisabled {
      color: #A3ABB4;
      border-color: #D9DEE5;
      background: linear-gradient(180deg, #F8FAFC 0%, #EEF2F6 100%);
      box-shadow: inset 0 0.1rem 0 rgba(255, 255, 255, 0.9);
      cursor: not-allowed;
      transform: none;
    }

    &.neutral {
      color: #5F6B7A;
      border-color: #CBD5E1;
      background: linear-gradient(180deg, #F8FAFC 0%, #E9EEF5 100%);
      box-shadow: 0 0.35rem 0.9rem rgba(15, 23, 42, 0.08), inset 0 0.1rem 0 rgba(255, 255, 255, 0.92);
    }

    &.neutral:hover {
      color: #374151;
      border-color: #AEBACC;
      background: linear-gradient(180deg, #FFFFFF 0%, #E3EAF2 100%);
      box-shadow: 0 0.5rem 1rem rgba(15, 23, 42, 0.11), inset 0 0.1rem 0 rgba(255, 255, 255, 0.94);
      transform: translateY(-0.04rem);
    }

    &.neutral:active {
      background: linear-gradient(180deg, #E7EDF4 0%, #DCE4EE 100%);
      box-shadow: 0 0.2rem 0.6rem rgba(15, 23, 42, 0.08), inset 0 0.12rem 0.2rem rgba(71, 85, 105, 0.12);
      transform: translateY(0);
    }

    &:disabled,
    &.disabled {
      cursor: not-allowed;
    }

    &:disabled:hover,
    &.disabled:hover {
      transform: none;
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 0.24rem rgba(34, 178, 74, 0.18), 0 0.55rem 1.25rem rgba(15, 23, 42, 0.12);
    }

    &.dismiss:focus-visible {
      box-shadow: 0 0 0 0.24rem rgba(191, 49, 49, 0.18), 0 0.55rem 1.25rem rgba(15, 23, 42, 0.12);
    }

    &.neutral:focus-visible {
      box-shadow: 0 0 0 0.24rem rgba(100, 116, 139, 0.16), 0 0.45rem 1rem rgba(15, 23, 42, 0.1);
    }
  }
`)

const ListItemNav = styled.a`
  display: flex;
  align-items: center;
  font-weight: 400;
  gap: 0.3rem;
  min-height: 4.2rem;
  border-radius: 0;
  padding: 0.5rem 0.8rem;
  margin: 0;
  background-color: ${(props) => props.attention && props.selected ? '#FFF1DB' : props.attention ? `#FFF8ED` : props.selected && !props.disabled ? "#EAF2FF" : props.disabled ? "#F8FAFC" : "#FFFFFF"};
  cursor: ${(props) => props.selected || props.noCursor ? "default" : props.disabled ? 'not-allowed' : "pointer"};
  color: ${(props) => props.disabled ? '#939599' : props.attention ? '#9A5A00' : '#245CA8'};
  border-top: ${(props) => props.top ? "none" : "none"};
  border-bottom: 0.1rem solid #D9E1EA;
  transition: background-color 120ms ease, color 120ms ease;

  .nav-index {
    width: 2.8rem;
    min-width: 2.8rem;
    color: inherit;
  }

  .main {
    color: ${(props) => props.disabled ? '#939599' : '#1F2937'};
    line-height: 1.2;
  }

  .label {
    color: #9A5A00;
    font-weight: 700;
  }

  svg {
    color: inherit;
  }

  &:hover {
    background-color: ${(props) => props.attention && props.selected ? '#FFE7C2' : props.attention ? '#FFF1DB' : props.selected && !props.disabled ? "#DDEBFF" : props.disabled ? "#F8FAFC" : "#F5F8FC"};
  }
`

export default LeadActionsNav;
